document.addEventListener('DOMContentLoaded', () => {
  let tabValue = '';
  let isItCountry = '';
  const uniqueParamsAnother = new URLSearchParams(window.location.search);
  tabValue = uniqueParamsAnother.get('tab');
  console.log(tabValue,'tabValue')


  if (tabValue == 'region') {
    const searchResultQuaryRegion = document.querySelectorAll('.search_result_quary_region');
    searchResultQuaryRegion.forEach(li => {
    li.classList.remove('hidden');
    });
    // cart region
    const regionListCart = document.querySelectorAll('.region_list_cart');
    regionListCart.forEach(li => {
    li.classList.remove('hidden');
    });
  }else if(tabValue == 'view-more'){
    const searchResultQuaryCountry = document.querySelectorAll('.search_result_quary_country');
    searchResultQuaryCountry.forEach(li => {
    li.classList.remove('hidden');
    });
    // all country cart
    const countryViewMoreListCart = document.querySelectorAll('.country_view_more_list_cart');
    countryViewMoreListCart.forEach(li => {
    li.classList.remove('hidden');
    });
  }else{
    console.log('tabValue--------else')
    isItCountry = 'country'
    const searchResultQuaryCountry = document.querySelectorAll('.search_result_quary_country');
    searchResultQuaryCountry.forEach(li => {
    li.classList.remove('hidden');
    });
    // home country cart
    const countryViewMoreListCartHomePage = document.querySelectorAll('.country_list_cart_home_page');
    countryViewMoreListCartHomePage.forEach(li => {
    li.classList.remove('hidden');
    });

    // view-more-wrapper
    const viewMoreWrapper = document.querySelectorAll('.view-more-wrapper');
    viewMoreWrapper.forEach(li => {
    li.classList.remove('hidden');
    });

    console.log('viewMoreWrapper',viewMoreWrapper)
  }
    const headContainer = document.querySelector('.tab_search');
    const container = document.querySelector('.search_box_container');
    const searchBox = document.querySelector('.search_box');
    const input = document.getElementById('collection_search_input');
    const icon = document.querySelector('.srch_icon');
    const body = document.getElementById('searchBoxBody');
    const resultList = document.querySelectorAll('.collection_name');
    const noMsg = document.querySelector('.no_results_message');

    let isExpanded = false;

    // Toggle expand only on icon click
    icon.addEventListener('click', (e) => {
      e.stopPropagation();
      isExpanded = !isExpanded;
      searchBox.classList.toggle('active', isExpanded);
      container.classList.toggle('expanded', isExpanded);
      headContainer.classList.toggle('on_mob_srch', isExpanded);

      if (isExpanded) {
        input.focus();
      } else {
        body.classList.remove('open');
      }
    });

    // Show results on input focus
    input.addEventListener('focus', () => {
      if (isExpanded) {
        body.classList.add('open');
      }
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) {
        isExpanded = false;
        container.classList.remove('expanded');
        headContainer.classList.remove('on_mob_srch');
        searchBox.classList.remove('active');
        body.classList.remove('open');
      }
    });

  // optional debounce helper
function debounce(fn, wait = 200) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}

const handleFilter = () => {
  const query = input.value.toLowerCase().trim();
  let matchCount = 0;

  // get tabValue dynamically if you keep it in the DOM,
  // fallback to global window.tabValue or 'all'


  resultList.forEach(link => {
    const item = link.closest('li');
    if (!item) return; // skip if structure unexpected

    const textMatches = link.textContent.toLowerCase().includes(query);

    // mark types on the item (safer to check the item directly)
    const isCountry = item.classList.contains('search_result_quary_country');
    const isRegion  = item.classList.contains('search_result_quary_region');

    // true when item belongs to the currently selected tab (or when tab is 'all')
    console.log(tabValue,isRegion)
    if(tabValue == 'view-more') {
      isItCountry = 'country'
    }
  const tabMatches = (isItCountry === 'country' && isCountry)
                  || (tabValue === 'region' && isRegion);

    if (textMatches && tabMatches) {
      item.classList.remove('hidden');
      matchCount++;
    } else {
      item.classList.add('hidden');
    }
  });

  // show/hide the "no results" message appropriately
  if (matchCount === 0) {
    noMsg.classList.remove('hidden');
  } else {
    noMsg.classList.add('hidden');
  }
};

// attach handler (with debounce recommended)
input.addEventListener('input', debounce(handleFilter, 150));
// or without debounce:
// input.addEventListener('input', handleFilter);

    const urlParams = new URLSearchParams(window.location.search);

    //  doesn't allow duplicate keys)
    const uniqueParams = new URLSearchParams();
    for (const [key, value] of urlParams.entries()) {
      if (!uniqueParams.has(key)) {
        uniqueParams.set(key, value);
      }
    }

    const uniqueQueryString = uniqueParams.toString();

    document.querySelectorAll('.collection_name').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault(); // Stop normal link behavior

        const selectedCoutryUrl = this.dataset.searchCountryurl; // from data-search-country="{{ c.url }}"
        const selectedCountryName = this.dataset.searchCountryname; // from data-search-country="{{ c.url }}"
        if (!selectedCoutryUrl) {
          console.log('No country URL found');
          return; // safety check
        }
        // Build URL
        const hasQuery = selectedCoutryUrl.includes('?');
        const cleanUrl = hasQuery ? selectedCoutryUrl.split('?')[0] : selectedCoutryUrl;
        const finalUrl = `${cleanUrl}?${uniqueQueryString}`;

        searchResultSelect(selectedCountryName);
        // Redirect
        window.location.href = finalUrl;
      });
    });
});

  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);

    //  doesn't allow duplicate keys)
    const uniqueParams = new URLSearchParams();
    for (const [key, value] of urlParams.entries()) {
      if (!uniqueParams.has(key)) {
        uniqueParams.set(key, value);
      }
    }

    const uniqueQueryString = uniqueParams.toString();

    document.querySelectorAll('.full-unstyled-link').forEach(link => {
      const href = link.getAttribute('href');

      if (href && !href.includes('javascript:void')) {
        const hasQuery = href.includes('?');
        const cleanHref = hasQuery ? href.split('?')[0] : href;

        // Append unique params only once
        link.setAttribute('href', `${cleanHref}?${uniqueQueryString}`);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.toggle-button');
    const items = document.querySelectorAll('.collection-list__item');
    const viewMoreBtns = document.querySelectorAll('.view-more-button');
    const countsEl = document.getElementById('collectionCounts');
    const regionCount = parseInt(countsEl.getAttribute('data-region_count'));
    const countryCount = parseInt(countsEl.getAttribute('data-country_count'));
    const btnRegion = document.getElementById('btn_region');
    const btnCountry = document.getElementById('btn_country');
    const individualSerach = document.querySelectorAll('.free_search');
    
    const pageUrl = new URL(window.location.href);

    let viewMoreClicked = false;

    function filterItems(type) {

      // let visibleCount = 0;
      // let visibleLimit = window.location.pathname.includes('/pages/buy-plans') ? 24 : 12;
      // const normalizedType = type.toLowerCase();
    
      // items.forEach(item => {
      //   const itemType = (item.dataset.type || 'default').toLowerCase();
    
      //   if (itemType === normalizedType || itemType === 'default') {
      //     visibleCount++;
      //     if (!viewMoreClicked && visibleCount > visibleLimit) {
      //       // item.classList.add('hidden');
      //     } else {
      //       // item.classList.remove('hidden');
      //     }
      //     // item.style.display = 'block';
      //   } else {
      //     // item.style.display = 'none';
      //   }
      // });
    
      // const totalVisible = Array.from(items).filter(item => {
      //   const itemType = (item.dataset.type || 'default').toLowerCase();
      //   return itemType === normalizedType || itemType === 'default';
      // }).length;
    
      // if (!viewMoreClicked && totalVisible > visibleLimit) {
      //   viewMoreBtns.forEach(btn => btn.style.display = 'inline-block');
      // } else {
      //   // viewMoreBtns.forEach(btn => btn.style.display = 'none');
      // }

      if(type == 'country'){
        btnRegion.classList.remove('active');
        btnCountry.classList.add('active');
      } else {
        btnCountry.classList.remove('active');
        btnRegion.classList.add('active');
      }
      
      // country-regions-selector search result
      const resultList = document.querySelector('.result_list');
      const typeClass =   `active_${type}_toggle`;
      resultList?.classList.add(typeClass);

    }

    // this function change the URL without reload 
    function updateTab(type) {
      if(type == 'region'){
         pageUrl.searchParams.set("tab", "region");
        window.location.href = pageUrl.toString(); // reloads with updated query
      }else if(type == 'country'){
        
        window.location.href ='/pages/buy-plans' 
      }
      console.log('buttons',buttons);
    }

    // Initial filter to 'country'
    const searchParams = new URLSearchParams(window.location.search);
    const tab = searchParams.get('tab')
    console.log(tab,'tab');
    filterItems(tab === 'region' ? 'region' : 'country');
    
    pushCountryRegion(countryCount,'country')//gtm for country

    buttons.forEach(button => {
      button.addEventListener('click', function () {
        viewMoreClicked = false;
        const type = this.dataset.type;
        if(type == "country"){
        pushCountryRegion(countryCount,type)//gtm for region
        }else if(type == "region"){
        pushCountryRegion(regionCount,type)//gtm for region
        }
        filterItems(type);
        updateTab(type)
      });
    });

    viewMoreBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        viewMoreClicked = true;
        const activeType = document.querySelector('.toggle-button.active')?.dataset.type || 'country';
        filterItems(activeType);
        // pageUrl.searchParams.set("tab", "view-more");
        window.location.href = '/pages/buy-plans?tab=view-more' // reloads with updated query

      });
    });
  });
